import { UserNotLoggedError } from "@hm/fundamental"
import { useAuth } from "@shared/lib/auth"
import { useTraceparent } from "@shared/lib/hooks"
import { CentralizedContainerBox, TraceIdBadge } from "@shared/ui"
import React from "react"
import { useTranslation } from "react-i18next"

export const UnauthorizedPage: React.FC = () => {
	const { t } = useTranslation("pages", { keyPrefix: "unauthorized" })
	const { redirectToAuthenticator } = useAuth()
	const { traceId } = useTraceparent()

	return (
		<CentralizedContainerBox data-cy="unauthorized-page-container">
			<div className="flex flex-col items-center">
				<UserNotLoggedError
					title={t("title")}
					description={t("description")}
					className="!h-auto !pb-6"
					pageOpenText={t("primaryButtonTitle")}
					onPageOpen={redirectToAuthenticator}
					data-cy="unauthorized-error"
				/>
				<TraceIdBadge
					traceId={traceId}
					data-cy="unauthorized-trace-id"
				/>
			</div>
		</CentralizedContainerBox>
	)
}
